import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem } from '@material-ui/core';
import Table from '../../../FlowConfigurationInputs/Table/Table';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { CredentialPicker } from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { isActionValueController } from "../../../../helpers/helper";
import AutomService from "../../../../services/AutomService/AutomService";

function Delete({ action, variables, setOpenVariable, automId, showAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.RESTFUL-WEB-SERVICE.';
    const [credVerify, setCredVerify] = useState('none');
    const [content, setContent] = useState('none');
    const headers = [label + 'ACTIVE', label + 'NAME', label + 'VALUE'];
    const options = {
        tableHeader: { headers, title: label + 'HEADER-FIELD' },
        tableBody: { headers, title: label + 'BODY-PARAMS' }
    };

    useEffect(() => {
        if (!action.fields.authentication) {
            action.fields.authentication = { value: 'none', isRequired: false };
        } else {
            setCredVerify(action.fields.authentication.value);
        }
        if (!action.fields.contentType) {
            action.fields.contentType = { value: 'none', isRequired: true };
        } else {
            setContent(action.fields.contentType.value);
        }
    }, [action]);

    const handleCredSelect = (event) => {
        let value = event.target.value;
        if (value !== 'basic') {
            delete action.fields.loginUser;
            delete action.fields.loginPassword;
        }
        action.fields.authentication.value = value;
        setCredVerify(value);
    }

    const handleContentSelect = (event) => {
        let value = event.target.value;
        if (value === 'urlencoded' || value === 'form-data') {
            action.fields.bodyParams = { type: 'TABLE', value: [] };
        } else {
            action.fields.bodyParams = { value: '' };
        }
        action.fields.contentType.value = value;
        setContent(value);
    }

    const handleClick = async () => {
        let res = isActionValueController(action.fields);
        if (res.indexOf(false) === -1) {
            action.automId = automId;
            action.automVersionId = automVersionId;
            let response = await AutomService.runAction(action);
            if (response) {
                showAlert(t('FLOW-MESSAGES.LIBRARY.' + response.message), response.status);
            }
        } else {
            showAlert(t('ACTIVE-DIRECTORY.NOT-NULL'), false);
        }
    }

    return (
        <div className="form-element">
            {t(label + 'REQUEST-URI')}
            <TextInput action={action} inputName="uriAddress" variables={variables} setOpenVariable={setOpenVariable}
                isRequired={true} fieldType="string" displayName={t(label + 'REQUEST-URI')} />
            <div className="form-element">
                {t(label + 'AUTHENTICATION')}
                <Select value={credVerify} onChange={handleCredSelect} variant="outlined" fullWidth
                    style={{ width: "90%" }}>
                    <MenuItem value="none">{t(label + 'NO-AUTH')}</MenuItem>
                    <MenuItem value="basic">{t(label + 'BASIC-AUTH')}</MenuItem>
                </Select>
            </div>
            {credVerify === 'basic' &&
                <div>
                    <div className="form-element">
                        {t(label + 'USERNAME')}
                        <CredentialPicker action={action} inputName="loginUser" variables={variables}
                            setOpenVariable={setOpenVariable} isRequired={true} />
                    </div>
                    <div className="form-element">
                        {t(label + 'PASSWORD')}
                        <CredentialPicker action={action} inputName="loginPassword" variables={variables}
                            setOpenVariable={setOpenVariable} isPassword={true} isRequired={true} />
                    </div>
                </div>
            }
            <div className="form-element">
                <Table action={action} inputName="headerParams" automVersionId={automVersionId} options={options.tableHeader}
                    isRequired={false} setOpenVariable={setOpenVariable} />
            </div>
            <div className="form-element">
                Content Type
                <Select value={content} onChange={handleContentSelect} variant="outlined" fullWidth
                    style={{ width: "90%" }}>
                    <MenuItem value="none">none</MenuItem>
                    <MenuItem value="urlencoded">urlencoded</MenuItem>
                    <MenuItem value="form-data">form-data</MenuItem>
                    <MenuItem value="application/json">application/json</MenuItem>
                    <MenuItem value="application/xml">application/xml</MenuItem>
                    <MenuItem value="text/plain">text/plain</MenuItem>
                    <MenuItem value="text/xml">text/xml</MenuItem>
                    <MenuItem value="text/html">text/html</MenuItem>
                </Select>
            </div>
            <div className="form-element">
                {content === 'urlencoded' || content === 'form-data' ?
                    <Table action={action} inputName="bodyParams" options={options.tableBody} automVersionId={automVersionId}
                        setOpenVariable={setOpenVariable} isRequired={false} formData={content === 'form-data'} />
                    : content === 'none' ? <div></div> :
                        <TextInput action={action} inputName="bodyParams" variables={variables}
                            setOpenVariable={setOpenVariable} multiline rows={4} fieldType={content === 'application/json' ? 'object' : 'string'} displayName={t(label + 'BODY-PARAMS')} />
                }
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.REPEATABLE.REPEAT.ASSIGN_TO_VARIABLE')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                    remove={['data table', 'array']} />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
            <button className="form-button" onClick={() => handleClick()}>Run Once</button>
        </div>
    )
}

export default Delete;
